<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">주문정보</span>
            <b-button variant="primary" style="float: right;" v-on:click="openUserInfoModal()">회원검색</b-button>
          </div>
          <b-row class="pt-2">
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                    <!-- <tr>
                      <td style="width:15%; vertical-align: middle;">주문자 ID</td>
                        <td class="tl">
                            <input type="text" v-model="userInfoOptions.user_id" style="width: 90%;" class="form-control" />
                        </td>
                    </tr> -->
                    <tr>
                      <td style="width:15%; vertical-align: middle;">담당자 이름</td>
                      <td class="tl">
                        <input type="text" v-model="userInfoOptions.name" style="width: 90%;" class="form-control" />
                      </td>
                      <td style="width:15%; vertical-align: middle;">담당자 직급</td>
                      <td class="tl" style="width:35%;">
                        <input type="text" v-model="userInfoOptions.level" style="width: 90%;" class="form-control" />
                      </td>
                    </tr>
                    <tr>
                      <td style="width:15%; vertical-align: middle;">기업명</td>
                      <td class="tl">
                        <input type="text" v-model="userInfoOptions.company" style="width: 90%;" class="form-control" />
                      </td>
                      <td style="width:15%; vertical-align: middle;">부서명</td>
                      <td class="tl" style="width:35%;">
                        <input type="text" v-model="userInfoOptions.department" style="width: 90%;" class="form-control" />
                      </td>
                    </tr>
                    <tr>
                      <td style="width:15%; vertical-align: middle;">이메일</td>
                      <td class="tl">
                          <input type="text" v-model="userInfoOptions.email" style="width: 90%;" class="form-control" />
                      </td>
                      <td style="width:15%; vertical-align: middle;">핸드폰번호</td>
                      <td class="tl">
                          <input type="text" v-model="userInfoOptions.mobile" style="width: 90%;" class="form-control" />
                      </td>
                    </tr>
                    <tr>
                      <td style="width:15%; vertical-align: middle;">사업자등록번호</td>
                      <td class="tl" style="width:35%;">
                        <input type="text" v-model="userInfoOptions.bl_number" style="width: 90%;" class="form-control" />
                      </td>
                      <td style="width:15%; vertical-align: middle;">전화번호</td>
                      <td class="tl" style="width:35%;">
                        <input type="text" v-model="userInfoOptions.phone" style="width: 90%;" class="form-control" />
                      </td>
                    </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">적용상품</span>
            <b-button variant="primary" style="float: right;" v-on:click="openProductInfoModal()">상품검색</b-button>
          </div>
          <b-row>
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">보고서명</td>
                    <td class="tl" style="width:35%;">
                      {{productInfoOptions.report_name}}
                    </td>
                    <td style="width:15%; vertical-align: middle;">사용권한(다운로드양식)</td>
                    <td class="tl" style="width:35%;">
                        <select id="selectDownloadTypeCode" class="form-control" v-on:change="slotDownloadTypeChange($event)" style="width: 90%;">
                            <option  v-for="row in pDownloadTypeList" :value="row.item_code" :selected="row.item_code === modifyItem.auth_download_type">{{ row.item_name }}</option>
                        </select>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">옵션명</td>
                    <td class="tl" style="width:35%; vertical-align: middle;">
                      {{productInfoOptions.name}}
                    </td>
                    <td style="width:15%; vertical-align: middle;">가격</td>
                    <td class="tl" style="width:35%; vertical-align: middle;">
                      보안 : {{Number(productInfoOptions.security_price).toLocaleString()}} 원
                      <br/>
                      일반 : {{Number(productInfoOptions.normal_price).toLocaleString()}} 원
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">결제정보</span>
          </div>
          <b-row>
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">결제금액</td>
                    <td class="tl" style="width:35%;">
                        <input type="text" v-model="modifyItem.price" style="width: 90%;" class="form-control" />
                    </td>
                    <td style="width:15%; vertical-align: middle;">최종 결제금액</td>
                    <td class="tl" style="width:35%; vertical-align: middle;">
                        <b>{{ (modifyItem.price - modifyItem.dc_price) | numberComma }} 원</b>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">할인금액</td>
                    <td class="tl" style="width:35%; vertical-align: middle;">
                        <input type="text" v-model="modifyItem.dc_price" style="width: 90%;" class="form-control" />
                    </td>
                    <td style="width:15%; vertical-align: middle;">할인 비고</td>
                    <td class="tl" style="width:35%; vertical-align: middle;">
                        <input type="text" v-model="modifyItem.extra_dc_desc" style="width: 90%;" class="form-control" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
              <span class="card-title wise-card-title" style="margin-right: 2%;">세금계산서 발행 정보</span>
              <b>※ 세금계산서 발행 여부 : </b>
              <c-switch type="text" variant="primary" v-model="modifyItem.tax_yn" on="On" off="Off" :pill="true" :checked="false"/>
          </div>
          <b-row v-if="modifyItem.tax_yn === 'Y'">
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">사업자 등록증</td>
                    <td class="tl">
                        <input type="file" class="form-control-file" id="file" ref="blFile" accept=".jpg, .jpeg, .png" style="padding:5px"/>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">계산서 수신 이메일</td>
                    <td class="tl">
                        <input type="text" v-model="modifyItem.invoice_mail" style="width: 90%;" class="form-control" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="float:right">
      <b-col md="6">
        <b-button variant="success" v-on:click="insertDrOrder()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
      </b-col>
      <b-col md="6">
        <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/order/userAuth'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
      </b-col>
    </b-row>
    <b-modal title="유저 정보 검색" size="lg" v-model="userFormModal" @ok="userFormModal = false" no-close-on-backdrop no-close-on-esc hide-footer>
      <userProductModal v-bind:userInfoOptions="userInfoOptions" v-bind:userFormModal="userFormModal" @childs-event="userModalClose" ref="userProductModalRef"></userProductModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-danger" @click="userFormModal = false">닫기</b-button>
      </span>
    </b-modal>
    <!-- <b-modal title="상품 정보 검색" size="xl" v-model="productFormModal" @ok="productFormModal = false" no-close-on-backdrop no-close-on-esc hide-footer>
      <productInfoModal v-bind:productInfoOptions="productInfoOptions" v-bind:productFormModal="productFormModal" @childs-event="productModalClose" ref="productInfoModalRef"></productInfoModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-danger" @click="productFormModal = false">닫기</b-button>
      </span>
    </b-modal> -->
    <b-modal title="보고서 상품 검색" size="xl" v-model="productFormModal" @ok="productFormModal = false"
    no-close-on-backdrop no-close-on-esc hide-footer>
      <reportOptModal v-bind:reportOptions="reportOptions" v-bind:productFormModal="productFormModal" @childs-event="productModalClose" ref="reportOptModalRef"></reportOptModal>
      <!-- <hr />
      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-primary" @click="productModalClose()">저장</b-button>
        <b-button variant="outline-success" @click="productFormModal = false">취소</b-button>
      </span> -->
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
// import userInfoModal from './UserInfoModal';
import userProductModal from './UserProductModal';
import productInfoModal from './ProductInfoModal';
import reportOptModal from './ReportOptModal';
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import { codeAPI } from '../../common/code.js';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import cSwitch from '../../components/Switch';

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    // userInfoModal,
    userProductModal,
    productInfoModal,
    reportOptModal,
    Multiselect,
    DatePicker,
    cSwitch,
  },
  data() {
    return {
      datepickerLang: {
          yearFormat: "YYYY년",
          monthFormat: "M월",
          days:["일","월","화","수","목","금","토"]
      },
      companyFlag: 'R', //수정,등록페이지 값
      endDateCheckYn: 'N',
      userAuthAddType: '',
      userInfoOptions: {
        user_id: '',
        name: '',
        level: '',
        company: '',
        department: '',
        email: '',
        mobile: '',
        bl_number: '',
        phone: '',
      },
      reportOptions: {
        optItems: [],
        pkgItems: [],
      },
      userAuthInCheckList: [],
      pTypeList: [],
      pPeriodList: [],
      pDownloadTypeList: [],
      productCompanyList: [],
      productInfoOptions: {
        price: 0,
        order_product_type: 'ORDER_PRODUCT_CODE_1',
        custom_start_date: '',
        custom_end_date: '',

        op_code: '', //보고서 코드
        op_name: '', //보고서 이름

        dr_code: '',      //보고서 코드
        dr_type_code: '', //보고서 타입 코드
        opt_code: '',     //옵션 코드
        opt_file_type: '',//옵션 파일 타입
        name: '',         //보고서 옵션명
        report_name: '',  //보고서 명
        type: '',         //옵션 타입
        exposure: '',     //옵션 순서
        security_price: 0,
        normal_price: 0,
      },
      userFormModal:false,
      productFormModal:false,
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      modifyItem: {
          user_id: '',
          p_type: '',
          p_code: '',
          p_name: '',
          auth_download_type: '',
          order_product_type: 'ORDER_PRODUCT_CODE_1',
          period_code: '',
          auth_start_date_tmp: null,
          auth_end_date_tmp: null,
          auth_start_date: '',
          auth_end_date: '',
          price: 0,
          dc_price: 0,
          amount: 0,
          tax_yn: 'N',

          extra_dc_desc: '',
          invoice_mail: '',
      },
      queryParams: {
          fix_yn: 'Y',
      },
    }
  },
  watch: {
        'modifyItem.price': function (value, oldValue) {
            // console.log('price', value, oldValue)
            this.modifyItem.price = value.replace(/[^0-9]/g,'');
        },
        'modifyItem.dc_price': function (value, oldValue) {
            this.modifyItem.dc_price = value.replace(/[^0-9]/g,'');
        },
    },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.findCodesList();
  },
  methods: {
    insertDrOrder() {
      var self = this;

      if(self.userInfoOptions.user_id == ''){
        swal.fire({
          type: 'error',
          title: '아이디를 검색해 주세요.',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }

      if(self.productInfoOptions.report_name == ''){
        swal.fire({
          type: 'error',
          title: '상품을 검색해 주세요.',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }

      if(self.modifyItem.price - self.modifyItem.dc_price < 0){
        swal.fire({
          type: 'error',
          title: "최종 결제금액이 0원 미만입니다.",
          showConfirmButton: false,
          timer: 1500
          // showCancelButton: false,
          // confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          // confirmButtonText: 'OK'
        })
        return false;
      }

      var token = sessionStorage.getItem("myToken");
      self.queryParams.user_id = self.userInfoOptions.user_id;
      self.queryParams.orderer_name = self.userInfoOptions.name;
      self.queryParams.company = self.userInfoOptions.company;
      self.queryParams.department = self.userInfoOptions.department;
      self.queryParams.level = self.userInfoOptions.level;
      self.queryParams.email = self.userInfoOptions.email;
      self.queryParams.mobile = self.userInfoOptions.mobile;
      self.queryParams.phone = self.userInfoOptions.phone;
      self.queryParams.bl_number = self.userInfoOptions.bl_number;

      self.queryParams.dc_price = self.modifyItem.dc_price;
      self.queryParams.extra_dc_desc = self.modifyItem.extra_dc_desc;
      self.queryParams.amount = self.modifyItem.price - self.modifyItem.dc_price;
      self.queryParams.order_price = self.modifyItem.price;
      self.queryParams.tax_yn = self.modifyItem.tax_yn;
      self.queryParams.invoice_mail = self.modifyItem.invoice_mail;

      self.queryParams.order_product_type = self.modifyItem.order_product_type;
      self.queryParams.op_code = self.productInfoOptions.dr_code;
      self.queryParams.op_name = self.productInfoOptions.report_name;
      self.queryParams.op_type_code = self.productInfoOptions.dr_type_code;
      self.queryParams.opt_code = self.productInfoOptions.opt_code;
      self.queryParams.opt_type = self.productInfoOptions.type;
      self.queryParams.opt_file_type = self.productInfoOptions.opt_file_type;

      const { manager_id } = this.$session.get('userInfo');
      self.queryParams.reg_id = manager_id;

      // console.log(self.queryParams);
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObj', param);

      if(self.modifyItem.tax_yn == 'Y'){
        //사업자등록증
        if(self.$refs.blFile.files.length > 0){
          data.append('blFile', self.$refs.blFile.files[0])
        }
      }

      self.$http.post('/api/insert/orderDrReportByAdmin?access_token='+token, data, null)
        .then((result) => {
          swal.fire({
            type: 'success',
            title: '보고서상품 주문이 등록되었습니다.',
            showConfirmButton: false,
            timer: 1500
          }).then(function() {
              window.location = "#/order/product";
          });
      })
    },
    openUserInfoModal() {
      var self = this;
      self.userFormModal = true;
    },
    userModalClose(data) {
      var self = this;
      self.userAuthAddType = data.type;
      self.userInfoOptions = data.userdata;
      self.userInfoOptions.email = self.userInfoOptions.user_id;
      // console.log('data.userdata',data.userdata);
      self.productInfoOptions = {
        price: 0,
        order_product_type: 'ORDER_PRODUCT_CODE_1',
        custom_start_date: '',
        custom_end_date: '',

        op_code: '', //보고서 코드
        op_name: '', //보고서 이름
        
        dr_code: '',      //보고서 코드
        dr_type_code: '', //보고서 타입 코드
        opt_code: '',     //옵션 코드
        opt_file_type: '',//옵션 파일 타입
        name: '',         //보고서 옵션명
        report_name: '',  //보고서 명
        type: '',         //옵션 타입
        exposure: '',     //옵션 순서
        security_price: 0,
        normal_price: 0,
      };
      self.endDateCheckYn = 'N';
      $('input[name="daterange"]').val('');

      var dataParam = {};
      dataParam.user_id = self.userInfoOptions.user_id;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(dataParam));
      var data = new FormData();
      data.append('userObjs', param);

      self.$http.post('/api/select/selectUserAuthInCheckList?access_token=' + token, data, null)
      .then((result) => {
        self.userAuthInCheckList = result.data;
      })
      self.userFormModal = false;
    },
    slotDownloadTypeChange(event) {
        this.modifyItem.auth_download_type = event.target.value;
        // 서비스 제공기간, 사용권한 변경시 서비스 이용금액 변경
        this.fnGetAmout();
    },
    // 서비스 제공기간, 사용권한 변경시 고정 기업 상품의 가격 가져오기
    fnGetAmout() {
      if(this.modifyItem.auth_download_type == 'AUTH_DOWNLOAD_TYPE_1'){ //보안파일
        this.modifyItem.price = this.productInfoOptions.security_price;
        this.productInfoOptions.opt_file_type = 'security';
      }else if(this.modifyItem.auth_download_type == 'AUTH_DOWNLOAD_TYPE_2'){ //일반파일
        this.modifyItem.price = this.productInfoOptions.normal_price;
        this.productInfoOptions.opt_file_type = 'normal';
      }
    },
    findCodesList() {
        var token = sessionStorage.getItem("myToken");
        // AUTH_DOWNLOAD_TYPE(계정권한 다운로드 형식) > 코드목록
        this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=AUTH_DOWNLOAD_TYPE')
        .then((result) => {
                const { data } = result;
                // console.log('AUTH_DOWNLOAD_TYPE', data);
                this.pDownloadTypeList = data;

                // companyFlag R 등록 화면용
                if(this.companyFlag === 'R') this.modifyItem.auth_download_type = this.pDownloadTypeList[0].item_code;
        })

    },
    openProductInfoModal() {
      var self = this;

      if(self.userInfoOptions.user_id == ''){
        swal.fire({
          type: 'error',
          title: '아이디를 먼저 검색해 주세요.',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }

      self.productFormModal = true;
    },
    productModalClose(productdata) {
      console.log('productdata',productdata);
      var self = this;
      self.productInfoOptions = {
        price: 0,
        order_product_type: 'ORDER_PRODUCT_CODE_1',
        custom_start_date: '',
        custom_end_date: '',

        op_code: '', //보고서 코드
        op_name: '', //보고서 이름
        
        dr_code: '',      //보고서 코드
        dr_type_code: '', //보고서 타입 코드
        opt_code: '',     //옵션 코드
        opt_file_type: '',//옵션 파일 타입
        name: '',         //보고서 옵션명
        report_name: '',  //보고서 명
        type: '',         //옵션 타입
        exposure: '',     //옵션 순서
        security_price: 0,
        normal_price: 0,
      };
      
      self.productInfoOptions = productdata;
      self.productFormModal = false;
      self.fnGetAmout();
    },
  },
}

$(document).ready(function(){
});

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}

.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/order/OrderProductForm.vue